"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.symbol.async-iterator");
require("core-js/modules/es6.symbol");
require("core-js/modules/es6.array.from");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.set");
require("core-js/modules/es6.string.starts-with");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _toConsumableArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.number.constructor");
var _RegionStorePane = _interopRequireDefault(require("@/views/goods_activity/RegionStorePane"));
var _goods_activity_combo = require("@/api/goods_activity/goods_activity_combo");
var _goods = require("@/api/goods/goods");
var _newLanding = require("@/api/decorate/newLanding");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'NewLandingEdit',
  // 上新落地页编辑
  components: {
    RegionStorePane: _RegionStorePane.default
  },
  props: {
    newLandingId: {
      type: [Number, String],
      default: null
    } // 上新落地页ID
  },
  data: function data() {
    return {
      resPath: '',
      // 资源前缀
      menuTypeList: [],
      // 点餐类型列表
      loading: false,
      form: {
        activityName: '',
        // 活动名称
        bannerUrl: '',
        // banner图片地址
        menuTypes: [],
        // 点餐类型
        executeDateList: [],
        // 活动时间范围
        executeTimeList: ['09:00', '23:00'],
        // 执行时间
        status: true,
        // 是否启用
        storeScope: 0,
        // 店铺范围：0=全部、1=指定
        checkedGoodsList: [],
        // 关联商品
        relatedStoreIdList: [] // 指定门店ID
      },
      bannerFileList: [],
      // banner图片回显列表
      regionStoreList: [],
      // 指定区域门店
      searchGoodsLoading: false,
      goodsTableKey: 0,
      // 商品表格key
      landingGoods: {},
      // 搜索选中的关联商品
      relatedGoodsList: [] // 关联商品列表
    };
  },
  created: function created() {
    this.getMenuType();
    this.queryRegionStoreList();
    if (this.newLandingId) {
      this.getNewLandingDetail();
    }
  },
  methods: {
    getNewLandingDetail: function getNewLandingDetail() {
      var _this = this;
      (0, _newLanding.newLandingDetail)(this.newLandingId).then(function (res) {
        var data = res.data;
        if (data) {
          var xyGaNewLanding = data.xyGaNewLanding || {};
          _this.form.activityName = xyGaNewLanding.activityName || '';
          _this.form.bannerUrl = xyGaNewLanding.bannerUrl || '';
          if (_this.form.bannerUrl) {
            _this.bannerFileList = [{
              name: 'banner图',
              url: _this.resPath + _this.form.bannerUrl
            }];
          }
          _this.form.menuTypes = data.menuTypes || [];
          _this.form.status = xyGaNewLanding.status !== undefined ? xyGaNewLanding.status : true;
          _this.form.storeScope = xyGaNewLanding.storeScope !== undefined ? Number(xyGaNewLanding.storeScope) : 0;
          _this.form.checkedGoodsList = data.checkedGoodsList || [];
          _this.form.relatedStoreIdList = data.relatedStoreIdList || [];
          if (data.executeDateList && data.executeDateList.length === 2) {
            _this.form.executeDateList = (0, _toConsumableArray2.default)(data.executeDateList);
          }
          if (data.executeTimeList && data.executeTimeList.length === 2) {
            _this.form.executeTimeList = (0, _toConsumableArray2.default)(data.executeTimeList);
          }
        }
      });
    },
    submitForm: function submitForm() {
      var _this2 = this;
      // 校验banner图
      if (!this.form.bannerUrl) {
        this.$message.error('请上传banner图');
        return;
      }
      // 准备提交数据
      var submitData = _objectSpread({}, this.form);
      // 处理活动时间范围：保留数组格式
      if (this.form.executeDateList && this.form.executeDateList.length === 2) {
        submitData.executeDateList = (0, _toConsumableArray2.default)(this.form.executeDateList);
      }
      // 处理执行时间：保留数组格式
      if (this.form.executeTimeList && this.form.executeTimeList.length === 2) {
        submitData.executeTimeList = (0, _toConsumableArray2.default)(this.form.executeTimeList);
      }
      this.loading = true;
      if (this.newLandingId) {
        // 编辑
        var editData = _objectSpread(_objectSpread({}, submitData), {}, {
          newLandingId: this.newLandingId
        });
        (0, _newLanding.newLandingEdit)(editData).then(function (res) {
          _this2.$message.success(res.message);
          _this2.loading = false;
          _this2.$emit('success');
        }, function (error) {
          console.error('编辑失败:', error);
          _this2.loading = false;
        });
      } else {
        // 新建
        (0, _newLanding.newLandingSave)(submitData).then(function (res) {
          _this2.$message.success(res.message);
          _this2.loading = false;
          _this2.$emit('success');
        }, function (error) {
          console.error('新建失败:', error);
          _this2.loading = false;
        });
      }
    },
    /**
     * banner图上传（单图，同菜品库编辑）
     */
    handleBannerUpload: function () {
      var _handleBannerUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
        var file, formData, res, url;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              file = _ref.file;
              if (this.validateFile(file)) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return");
            case 1:
              formData = new FormData();
              formData.append('file', file);
              _context.next = 2;
              return (0, _goods.uploadPhotoAddOrUpd)(formData);
            case 2:
              res = _context.sent;
              url = res.data;
              this.form.bannerUrl = url;
              this.bannerFileList = [{
                name: 'banner图',
                url: this.resPath + url
              }];
              this.$message.success('上传成功');
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleBannerUpload(_x) {
        return _handleBannerUpload.apply(this, arguments);
      }
      return handleBannerUpload;
    }(),
    handleRemoveBannerFile: function handleRemoveBannerFile() {
      this.bannerFileList = [];
      this.form.bannerUrl = '';
    },
    /**
     * 验证上传文件（仅图片，≤2MB）
     */
    validateFile: function validateFile(file) {
      var isImage = file.type.startsWith('image/');
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      if (file.size / 1024 / 1024 > 2) {
        this.$message.error('图片大小不能超过 2MB!');
        return false;
      }
      return true;
    },
    handlePreview: function handlePreview(file) {
      window.open(file.url);
    },
    handleRegionStoreChange: function handleRegionStoreChange() {
      // 重新收集所有区域的选中门店ID
      var allCheckedStoreIds = [];
      if (this.$refs) {
        // 遍历所有 RegionStorePane 组件，收集每个区域选中的门店
        var _iterator = _createForOfIteratorHelper(this.regionStoreList),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var regionStore = _step.value;
            var refKey = 'regionStorePane_' + regionStore.regionId;
            var paneRef = this.$refs[refKey];
            if (paneRef && paneRef.length > 0) {
              var checkedIds = paneRef[0].getCheckedStoreIds();
              if (checkedIds && checkedIds.length > 0) {
                allCheckedStoreIds.push.apply(allCheckedStoreIds, (0, _toConsumableArray2.default)(checkedIds));
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      // 去重并更新
      this.form.relatedStoreIdList = (0, _toConsumableArray2.default)(new Set(allCheckedStoreIds));
    },
    handleStoreScopeChange: function handleStoreScopeChange(val) {
      // 当切换门店范围时，清空或重置 relatedStoreIdList
      if (val === 0) {
        // 切换到全部门店，清空指定门店列表
        this.form.relatedStoreIdList = [];
      }
    },
    removeLandingGoods: function removeLandingGoods(item) {
      var index = -1;
      for (var i = 0; i < this.form.checkedGoodsList.length; i++) {
        var goods = this.form.checkedGoodsList[i];
        if (item.goodsFnId === goods.goodsFnId) {
          index = i;
          break;
        }
      }
      if (index !== -1) {
        this.form.checkedGoodsList.splice(index, 1);
      }
    },
    addLandingGoods: function addLandingGoods() {
      if (this.landingGoods && this.landingGoods.goodsFnId) {
        var exist = false;
        for (var i = 0; i < this.form.checkedGoodsList.length; i++) {
          var goods = this.form.checkedGoodsList[i];
          if (this.landingGoods.goodsFnId === goods.goodsFnId) {
            exist = true;
            break;
          }
        }
        if (!exist) {
          this.landingGoods.sorts = this.form.checkedGoodsList.length + 1;
          this.form.checkedGoodsList.push(this.landingGoods);
        }
        this.landingGoods = {};
      }
    },
    searchGoods: function searchGoods(query) {
      var _this3 = this;
      this.searchGoodsLoading = true;
      (0, _goods_activity_combo.queryGoodsSearch)({
        keywords: query
      }).then(function (res) {
        var data = res.data;
        if (data) {
          _this3.relatedGoodsList = data.goodsList || [];
          _this3.searchGoodsLoading = false;
        }
      }, function () {
        _this3.searchGoodsLoading = false;
      });
    },
    queryRegionStoreList: function queryRegionStoreList() {
      var _this4 = this;
      (0, _goods_activity_combo.queryRegionStoreList)().then(function (res) {
        var data = res.data;
        if (data) {
          _this4.regionStoreList = data.storeRegions || [];
        }
      });
    },
    getMenuType: function getMenuType() {
      var _this5 = this;
      (0, _goods_activity_combo.queryMenuType)().then(function (res) {
        var data = res.data;
        if (data) {
          _this5.menuTypeList = data.records || [];
        }
      });
    }
  }
};